import { render, staticRenderFns } from "./AddCampusActivities.vue?vue&type=template&id=ee50456e&scoped=true"
import script from "./AddCampusActivities.vue?vue&type=script&lang=js"
export * from "./AddCampusActivities.vue?vue&type=script&lang=js"
import style0 from "./AddCampusActivities.vue?vue&type=style&index=0&id=ee50456e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee50456e",
  null
  
)

export default component.exports